import { render } from "./MainCard.vue?vue&type=template&id=3bbf7ab2&scoped=true"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"

import "./MainCard.vue?vue&type=style&index=0&id=3bbf7ab2&lang=scss&scoped=true"
import "./MainCard.vue?vue&type=style&index=1&id=3bbf7ab2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbf7ab2"]])

export default __exports__